export default __webpack_public_path__ + "static/media/pp-sh-2.40b5705b.png";